var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{staticClass:"mt-n1 mb-1",attrs:{"rules":_vm.rules,"label":_vm.label,"value":_vm.fieldValue,"readonly":_vm.readonly,"required":_vm.required,"false-value":false,"true-value":true},on:{"change":_vm.sendToParent},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }